import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP7PoorRoasNew202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p7_poor_roas_new_202602",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 782,
  clicks: 18,
  adsSpendDollars: 84,
  budgetDollars: 400,
  salesDollars: 349,
  bestEstimateRoas: 4.15,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.21,
  newCustomersAcquired: 2,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
